module.exports = __webpack_public_path__ + "img/vut.859836e7.svg";